import { useState, useEffect, useCallback } from "react";

const STORAGE_KEY = "cv_parse_history";
const MAX_ITEMS = 50;

export function useParseHistory() {
  const [history, setHistory] = useState([]);

  useEffect(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored) setHistory(JSON.parse(stored));
    } catch {
      setHistory([]);
    }
  }, []);

  const addEntry = useCallback((result, filename) => {
    const entry = {
      id: Date.now().toString(),
      filename,
      timestamp: new Date().toISOString(),
      result,
    };
    setHistory((prev) => {
      const next = [entry, ...prev].slice(0, MAX_ITEMS);
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
      } catch {}
      return next;
    });
    return entry;
  }, []);

  const removeEntry = useCallback((id) => {
    setHistory((prev) => {
      const next = prev.filter((e) => e.id !== id);
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
      } catch {}
      return next;
    });
  }, []);

  const clearAll = useCallback(() => {
    setHistory([]);
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch {}
  }, []);

  return { history, addEntry, removeEntry, clearAll };
}
